/**
 * CouponWidgetContent - Wrapper that aligns web with mobile logic.
 *
 * Derives filter and title from variant (innerFilter for eWallet, i18n title).
 * Renders CouponWidget with those values so Home can use
 * <CouponWidgetContent variant="voucher" /> and <CouponWidgetContent variant="eWalletVoucher" />.
 *
 * @see mobile: module-theme-hermes/src/modules/sales-rule/components/coupon-widget-content/
 */

'use client';

import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Routes } from '@/config/routes';
import { CouponWidget } from '@/nova/modules/coupon-wallet';
import type { CouponWidgetContentProps } from './coupon-widget-content.types';

export const CouponWidgetContent: React.FC<CouponWidgetContentProps> = ({
    variant = 'voucher',
    filter,
    limitItem,
    viewAllHref = Routes.couponWallet,
    className,
    isMobile = false,
}) => {
    const { t } = useTranslation('flash-sale');

    const innerFilter = useMemo(() => {
        if (filter) return filter;
        return variant === 'eWalletVoucher' ? { partner: { eq: '*' } } : {};
    }, [filter, variant]);

    const title =
        variant === 'voucher'
            ? t('text_discount_voucher', 'Voucher giảm giá')
            : t('text_ewallet_offers', 'Ưu đãi ví điện tử');

    return (
        <CouponWidget
            title={title}
            variant={variant}
            filter={innerFilter}
            limitItem={limitItem}
            viewAllHref={viewAllHref}
            className={className}
            isMobile={isMobile}
        />
    );
};

CouponWidgetContent.displayName = 'CouponWidgetContent';
